import React from 'react';
import {
  MotifFormField,
  MotifSelect,
  MotifLabel,
  MotifOption,
} from '@ey-xd/motif-react';

export default (props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}
    >
      <MotifFormField>
        <MotifLabel data-testid="lblTRSName">TRS Name</MotifLabel>
        <MotifSelect
          name={`trsName.${props.data.uniqueKey}`}
          id={`trsName.${props.data.uniqueKey}`}
          data-testid="divTRSName"
          placeholder="Select a TRS..."
          className="motif-select-hide-clear"
          filter
          lblPosition="out"
          value={props.data.trsName}
          onChange={(value) => {
            props.handleTRSNameChange(
              value,
              props.data.uniqueKey,
              props.colDef.field
            );
          }}
        >
          {props.options.map((co) => (
            <MotifOption data-testvalue={co.text} key={co.key} value={co.value}>
              {co.text}
            </MotifOption>
          ))}
        </MotifSelect>
      </MotifFormField>
    </div>
  );
};
